"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
import { ArtistActivityBadge } from "@/components/waves/drops/ArtistActivityBadge";
import { useArtistPreviewModal } from "@/hooks/useArtistPreviewModal";
import { getSubmissionCount, getTrophyArtworkCount } from "@/helpers/artist-activity.helpers";
interface MemesLeaderboardDropArtistInfoProps {
  readonly drop: ExtendedDrop;
}
const MemesLeaderboardDropArtistInfo = t0 => {
  const $ = _c(35);
  const {
    drop
  } = t0;
  const {
    isModalOpen,
    modalInitialTab,
    handleBadgeClick,
    handleModalClose
  } = useArtistPreviewModal();
  const submissionCount = getSubmissionCount(drop.author);
  const hasSubmissions = submissionCount > 0;
  const trophyCount = getTrophyArtworkCount(drop.author);
  const hasTrophyArtworks = trophyCount > 0;
  const hasActivityBadge = hasSubmissions || hasTrophyArtworks;
  let t1;
  if ($[0] !== drop) {
    t1 = <WaveDropAuthorPfp drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drop.author.handle) {
    t2 = drop.author?.handle ? <UserProfileTooltipWrapper user={drop.author.handle}><Link href={`/${drop.author?.handle}`} onClick={_temp} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{drop.author?.handle}</span></Link></UserProfileTooltipWrapper> : <Link href={`/${drop.author?.handle}`} onClick={_temp2} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{drop.author.handle}</span></Link>;
    $[2] = drop.author.handle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== drop.author.level) {
    t3 = !!drop.author?.level && <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[4] = drop.author.level;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== drop.id || $[7] !== handleBadgeClick || $[8] !== hasActivityBadge || $[9] !== submissionCount || $[10] !== trophyCount) {
    t4 = hasActivityBadge && <ArtistActivityBadge submissionCount={submissionCount} trophyCount={trophyCount} onBadgeClick={handleBadgeClick} tooltipId={`leaderboard-activity-badge-${drop.id}`} />;
    $[6] = drop.id;
    $[7] = handleBadgeClick;
    $[8] = hasActivityBadge;
    $[9] = submissionCount;
    $[10] = trophyCount;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="tw-text-sm tw-text-iron-500">•</span>;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== drop.created_at) {
    t6 = <WaveDropTime timestamp={drop.created_at} />;
    $[13] = drop.created_at;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t6) {
    t7 = <div className="-tw-mt-0.5 tw-flex tw-flex-wrap tw-items-center tw-gap-x-2">{t2}{t3}{t4}{t5}{t6}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const t8 = drop.winning_context?.decision_time || null;
  let t9;
  if ($[20] !== drop.rank || $[21] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-gap-x-2"><WinnerDropBadge rank={drop.rank} decisionTime={t8} /></div>;
    $[20] = drop.rank;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t7 || $[24] !== t9) {
    t10 = <div className="tw-flex tw-h-12 tw-flex-col tw-justify-between">{t7}{t9}</div>;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== drop.author || $[27] !== handleModalClose || $[28] !== isModalOpen || $[29] !== modalInitialTab) {
    t11 = <ArtistPreviewModal isOpen={isModalOpen} onClose={handleModalClose} user={drop.author} initialTab={modalInitialTab} />;
    $[26] = drop.author;
    $[27] = handleModalClose;
    $[28] = isModalOpen;
    $[29] = modalInitialTab;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t1 || $[32] !== t10 || $[33] !== t11) {
    t12 = <div className="tw-flex tw-gap-x-3">{t1}{t10}{t11}</div>;
    $[31] = t1;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
};
export default MemesLeaderboardDropArtistInfo;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}